import React, { useState, useEffect } from "react";
import {
  ScrollableContent,
  ModalHeader,
  ModalRow,
  ModalRowValue,
  ModalSection,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Config from "../../Config";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../helpers";

const ViewStampDetails = ({ setViewDetails, selectedData }) => {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onClose = () => {
    setViewDetails(false);
  };

  const getStatusText = (status) => {
    return status === Config.STAMP_PAPERS_STATUS.AVAILABLE
      ? "Available"
      : "Allocated";
  };

  const getStatusColor = (status) => {
    return status === Config.STAMP_PAPERS_STATUS.AVAILABLE
      ? "text-green-600"
      : "text-orange-600";
  };

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <h1 className="text-white text-lg font-medium">Stamp Details</h1>
        <button
          onClick={() => {
            onClose();
          }}
        >
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      <ModalProfileHeader
        title="Stamp Details"
        name={capitalizeFirstLetter(selectedData?.propName)}
        subtitle={`#${selectedData?.streetAddress}`}
        amountLabel={"Total Stamps"}
        amount={selectedData?.stamps?.length || 0}
        image={selectedData?.profilePicture}
        onClose={onClose}
        showCurrency={false}
      />

      <Content>
        <ScrollableContent>
          <Wrappers>
            {selectedData?.stamps?.length > 0 ? (
              selectedData?.stamps?.map((stamp, index) => (
                <ModalSection key={index}>
                  <ModalRow>
                    <FlexCol>
                      <LabelShow>Stamp ID</LabelShow>
                      <ModalRowValue className="font-medium">
                        #{stamp.stampId}
                      </ModalRowValue>
                    </FlexCol>
                    <FlexCol>
                      <LabelShow>Status</LabelShow>
                      <ModalRowValue className={getStatusColor(stamp.status)}>
                        {getStatusText(stamp.status)}
                      </ModalRowValue>
                    </FlexCol>
                  </ModalRow>

                  {stamp.status === Config.STAMP_PAPERS_STATUS.ALLOTTED && (
                    <>
                      <ModalRow>
                        <FlexCol>
                          <LabelShow>Tenant Name</LabelShow>
                          <ModalRowValue>
                            {stamp.tenantName || "—"}
                          </ModalRowValue>
                        </FlexCol>
                        <FlexCol>
                          <LabelShow>Issue Date</LabelShow>
                          <ModalRowValue>
                            {moment(stamp.updatedOn).format("DD, MMM YY")}
                          </ModalRowValue>
                        </FlexCol>
                      </ModalRow>
                    </>
                  )}
                </ModalSection>
              ))
            ) : (
              <ModalSection>
                <ModalRowValue className="text-gray-400 text-center py-4">
                  No stamps available
                </ModalRowValue>
              </ModalSection>
            )}
          </Wrappers>
        </ScrollableContent>
      </Content>
    </Container>
  );
};

// Styled components

const Wrappers = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const LabelShow = tw.label`text-sm text-gray-400 font-normal`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
export default ViewStampDetails;
